export default {"src":"/_next/static/media/twitter-icon.f5e6f85e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};